import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./LedgerHistory.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchViewDocumentHistory } from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as SquareIcon } from "../../../../assets/images/squareIcon.svg";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import Loader from "../../../../commons/Loader/Loader";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const LedgerHistory = ({
  open,
  handleClose,
  connectionId,
  viewDocData,
  activeCounterparty,
}) => {

  const selfListingData = viewDocData?.[0]?.selfListing?.companyName;
  const ledgerHistory = activeCounterparty?.ledgers || [];
  const dispatch = useDispatch();
  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.bankingSlice
  );

  // useEffect(() => {
  //   if (connectionId) {
  //     dispatch(fetchViewDocumentHistory(connectionId));
  //   }
  // }, [dispatch, connectionId]);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        setPreviewFileUrl(url);
        setSelectedDocumentId(id);
        setPreviewModal(true);
      } else {
        alert("Document URL not found");
      }
    } catch (err) {
      alert("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setSelectedDocumentId(null);
  };


  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">View Ledger</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.docContainer}>
            {/* Header Row */}
            <div className={`tableHeading ${Styles.tableHeader}`}>
              <div>Month</div>

              <div>Injection</div>

              <div>Drawal</div>

              <div style={{ width: "10%" }}>View</div>
            </div>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : error ? (
                <p className={Styles.error}>{error}</p>
              ) : ledgerHistory?.length > 0 ? (
                ledgerHistory.map((doc) => (
                  <div
                    className={`tableDetails ${Styles.tableHeader}`}
                    key={doc.id}
                  >
                    <div>{doc.month}</div>
                    <div>{doc.amount}</div>
                    <div>{doc.againstAmount}</div>
                    <div>
                      {loading === doc?.ledgerDocumentId ? (
                        <span>Loading...</span>
                      ) : (
                        <div
                          className={`display_flex_row_center ${Styles.viewSection}`}
                        >
                          <span>View File</span>
                          <span
                            onClick={() => handleViewDoc(doc?.ledgerDocumentId)}
                          >
                            <SquareIcon />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p className={Styles.no_ledger_text}>No ledger history found.</p>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        disableDownload={true}
        documentId={selectedDocumentId}
      />
    </>
  );
};

export default LedgerHistory;
